import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";




import { useDashboardContext } from "../../../context/dashboardContext";
import "../dashboardInfoPiecePage.css";
import { useSafeNavigate } from "../../../components/unloadBlocker";
import { PieceResponseDTOAdmin, PieceResponseDTOOwn } from "../../../openapi-generated-client";
import ConfirmDeletePiecePopUp from "../../../pageparts/popup/confirmDeletePiecePopUp";
import Button from "../../../components/button";
import EyeIcon from "../../../assets/icons/eyeIcon";
import TrashBinIcon from "../../../assets/icons/trashBinIcon";
import { openPopUp } from "../../../components/popUp";
import EditIcon from "../../../assets/icons/editIcon";
import InfoIcon from "../../../assets/icons/infoIcon";
import InfoBoxes from "../../../components/infoBoxes";

export default function DashboardAdminPiecePage() {

    const {appContext, sessionId} = useDashboardContext();
    const { pieceController } = appContext;

    const [deleteLoading, setDeleteLoading] = useState(false);
    const [deleteError, setDeleteError] = useState("");

    const [unlistLoading, setUnlistLoading] = useState(false);
    const [unlistError, setUnlistError] = useState("");

    const {id} = useParams();

    const navigate = useSafeNavigate(useNavigate());

    const [data, setData] = useState<PieceResponseDTOAdmin>();

    async function fetchData() {
        if(isNaN(Number(id))) {
            window.location.href = "/error/2";
            return;
        };
        setData((await pieceController.getPieceAdmin(Number(id), sessionId)).data)
    }

    useEffect(() => {
        fetchData();
    }, [id, sessionId]);

    if(data == undefined) {
        return <></>;
    }

    async function sendUnlistPiece(unlist: boolean) {
        setUnlistLoading(true);
        if(unlist) {
            await pieceController.unlistPiece(Number(id), sessionId).catch((e) => {
                setUnlistError(e.message);
            });
        }else {
            await pieceController.listPiece(Number(id), sessionId).catch((e) => {
                setUnlistError(e.message);
            });
        }
        setUnlistLoading(false);
        fetchData();
    }

    async function sendDeletePiece() {
        setDeleteLoading(true);
        await pieceController.deletePiece(Number(id), sessionId).catch((e) => {
            setUnlistError(e.message);
        });
        setDeleteLoading(false);
        window.open("/dashboard/mypieces", "_self");
    }

    var infoTitle = "";
    var infoMessage = "";


    if(!data.confirmed && !data.unlisted) {
        infoTitle = "Your piece still needs to be confirmed";
        infoMessage = data.confirmedMessage || "";
    }
    if(unlistError) {
        infoTitle = unlistError;
    }
    if(deleteError) {
        infoTitle = deleteError;
    }

    return <div className="inner-page own-piece-info">
            <h1>{data.title}</h1>
            <Button widthFitContent onClick={() => {
                navigate("/dashboard/mypieces/" + id + "/edit");
            }}><EditIcon/>Edit</Button>
            {infoTitle.length > 0 ? <div className="info">
                <p><InfoIcon/><p>{infoTitle}</p></p>
                <p><p>{infoMessage}</p></p>
            </div> : <></>}
            <div className="buttons">
                <Button disabled={!data.confirmed} onClick={() => {
                    if(!data.confirmed) {
                        setUnlistError("Your piece needs to be confirmed before you can unlist ist");
                        return;
                    }
                    sendUnlistPiece(!data.unlisted);
                }}><EyeIcon off={data.unlisted}/>Unlist</Button>
                <Button onClick={() => {
                    openPopUp(<ConfirmDeletePiecePopUp onDelete={sendDeletePiece}/>);
                }}><TrashBinIcon/>Delete</Button>
            </div>
            <InfoBoxes infos={[
                {
                    title: "Downloads",
                    value: data.downloads
                },
                {
                    title: "Likes",
                    value: data.likes
                },
                {
                    title: "Purchases",
                    value: data.sales
                },
                {
                    title: "Revenue",
                    value: data.earnedMoney
                }
            ]}/>
        </div>;
}